const DIETS_AND_DIET_CATEGORIES_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  initialData: [],
  latestEvent: undefined,
  data: [],
  isDirty: false,
  dataForRenaming: undefined,
}

export default DIETS_AND_DIET_CATEGORIES_INITIAL_STATE
